import { cn } from "@/lib/utils";

interface LoadingLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES = {
  sm: "h-7 w-7",
  md: "h-8 w-8",
  lg: "h-10 w-10",
} as const;

/**
 * Branded loading spinner. Olive accent ring on warm ink-100 track.
 * Used for page-level and in-card loading inside the authenticated app.
 * For pre-auth surfaces (sso callback, verify, etc.) use AuthStatusScreen
 * with state="loading" instead.
 */
export function LoadingLogo({
  size = "md",
  className,
}: LoadingLogoProps): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={cn("flex items-center justify-center", className)}
    >
      <div
        className={cn(
          "rounded-full border-[3px] animate-spin motion-reduce:animate-none",
          "border-[var(--fx-ink-100)] border-t-[var(--fx-accent-500)]",
          SIZE_CLASSES[size]
        )}
      />
    </div>
  );
}
